module.exports = __webpack_public_path__ + "static/media/Avatars_Male-10.a05b13f4.png";